import { render, staticRenderFns } from "./CollectionItemInformation.vue?vue&type=template&id=0f3ad2ac&scoped=true&"
import script from "./CollectionItemInformation.vue?vue&type=script&lang=js&"
export * from "./CollectionItemInformation.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItemInformation.vue?vue&type=style&index=0&id=0f3ad2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ad2ac",
  null
  
)

export default component.exports